module.exports = __webpack_public_path__ + "img/9788982735332.de19f14e.jpg";